import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex items-center justify-center h-screen"
}

import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import OaiLiveImagePlayer from "shared/components/camera/OaiLiveImagePlayer.vue";
import OaiLiveVideoPlayer from "shared/components/camera/OaiLiveVideoPlayer.vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import LogoWatermark from "shared/components/other/LogoWatermark.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useFullWindow4to3RatioDimensionStyle } from "shared/composables/screen";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import logger from "shared/services/logger";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveView',
  setup(__props) {

const isLoading = ref(true);
const shouldShowImage = ref(false);

const route = useRoute();

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

onMounted(() => {
  PublicTokenRepository.loadPublicTokenByToken(currentCustomerName, currentSiteId)
    .then((publicToken) => {
      shouldShowImage.value = publicToken.claims.includes("camera_live_image");
    })
    .catch((error) => {
      if (!PublicTokenRepository.isPublicTokenAuthError(error)) {
        logger.error(error);
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(_unref(fullWindow4to3RatioDimensionStyle)),
        class: "relative"
      }, [
        (shouldShowImage.value)
          ? (_openBlock(), _createBlock(OaiLiveImagePlayer, {
              key: 0,
              cameraId: _unref(route).params.camera_id as string,
              showControls: false,
              reloadIntervalInMs: 60 * 60 * 1000
            }, null, 8, ["cameraId"]))
          : (_openBlock(), _createBlock(OaiLiveVideoPlayer, {
              key: 1,
              cameraId: _unref(route).params.camera_id as string
            }, null, 8, ["cameraId"])),
        _createVNode(LogoWatermark, { class: "absolute top-2 right-2" })
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
}
}

})